import StepRoute from '../classes/step-route.class';
import RouteNames from '../constants/route-names';

const route = new StepRoute(
  RouteNames.AppointmentSummary,
  'summary',
  () => import('@/views/steps/SummaryStep.vue'),
);

route.requiresAuthentication();

export default route.getRoute();
